import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import { fetchClientData } from '../../redux/client/clientSlice';
import { useDispatch } from 'react-redux';
import api from '../../utils/api';
import Swal from 'sweetalert2';
import socket from '../../context/socket';

const ContactDetailsModal = ({ show, onHide, proofType, roomId, clientData, kycDoc }) => {
  // console.log("clientData", clientData);
  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
  const [alert, setAlert] = useState({ visible: false, message: '', variant: '' });
  const [loading, setLoading] = useState(false);
  const [dataAvailable, setDataAvailable] = useState(false); // Track data availability
  const dispatch = useDispatch();
  useEffect(() => {
    const clientAddressProof =
      (kycDoc && kycDoc.find((item) => item.doctype === "nri_details")) || [];
    const data = clientAddressProof.data ? clientAddressProof.data[0] : null;
    
    if (data !== null) {
      setDataAvailable(true);
      setValue("nri_address", data.nri_address || "");
      setValue("nri_city", data.nri_city || "");
      setValue("nri_pin_code", data.nri_pin_code || "");
      setValue("nri_country", data.nri_country || "");
    } else {
      setDataAvailable(false); // No data found, set to false
    }
  }, [clientData, kycDoc, setValue]);

  const onSubmit = async (formData) => {
        Swal.fire({
          text: "Please wait...",
          imageUrl: "https://www.finedge.in/assets/images/download.gif",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
    setLoading(true);
    const allData = {
      ...formData,
      _id: roomId,
      client_email: clientData.email,
      data_status: true,

    };

    try {
      const response = await api.post(`advisor/update_nri_kyc`, allData);
      if (response.status ===200||response.status===201) {
        Swal.fire({
          icon: "success",
          text: response?.message || "Client data updated successfully",
          title: "Success",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        }).then(() => {
          setValue("");
          onHide();
          dispatch(fetchClientData(roomId));
    
          socket.emit("join", { room: roomId });
          socket.emit("message_to", 
            {
              room: roomId,
              data: { message: response?.message || "Client data updated successfully",
              type: "success",}
            
            })
          console.log("emitted data message_to", roomId, "success");
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: response.data?.message || 'Something went wrong!',
          confirmButtonColor: '#d33',
        });
      }
    } catch (error) {
      console.error('Error updating NRI details:', error);
      setAlert({ visible: true, message: 'An error occurred while updating NRI details. Please try again.', variant: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  const renderAlert = () => (
    alert.visible && (
      <Alert variant={alert.variant} onClose={() => setAlert({ ...alert, visible: false })} dismissible>
        {alert.message}
      </Alert>
    )
  );

  return (
    <Modal show={show} onHide={onHide} size="md">
      <Modal.Header closeButton style={{ backgroundColor: '#c7e69b' }}>
        <Modal.Title>{proofType} Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {renderAlert()}

          {/* NRI Address */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="nri_address">
                <Form.Label>NRI Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter NRI address"
                  {...register("nri_address", { required: "NRI Address is required" })}
                />
                {errors.nri_address && <span className="text-danger">{errors.nri_address.message}</span>}
              </Form.Group>
            </Col>
          </Row>

          {/* NRI City */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="nri_city">
                <Form.Label>NRI City</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter NRI city"
                  {...register("nri_city", { required: "NRI City is required" })}
                />
                {errors.nri_city && <span className="text-danger">{errors.nri_city.message}</span>}
              </Form.Group>
            </Col>
          </Row>

          {/* NRI Pin Code */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="nri_pin_code">
                <Form.Label>NRI Pin Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter NRI pin code"
                  {...register("nri_pin_code", { required: "NRI Pin Code is required" })}
                />
                {errors.nri_pin_code && <span className="text-danger">{errors.nri_pin_code.message}</span>}
              </Form.Group>
            </Col>
          </Row>

          {/* NRI Country */}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Group controlId="nri_country">
                <Form.Label>NRI Country</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter NRI country"
                  {...register("nri_country", { required: "NRI Country is required" })}
                />
                {errors.nri_country && <span className="text-danger">{errors.nri_country.message}</span>}
              </Form.Group>
            </Col>
          </Row>

          <Modal.Footer className="border-0">
            <Button variant="secondary" onClick={onHide}>Close</Button>
            <Button variant="success" type="submit" disabled={loading}>
              {loading ? 'Updating...' : dataAvailable ? 'Update' : 'Submit'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ContactDetailsModal;
